import $marketAxios from "@/services/config/market-axios";

class UserCenterService {
  getCoinsList() {
    return $marketAxios.get("/uc/coin/all");
  }

  getTransactionTypes() {
    return $marketAxios.get("/uc/asset/transaction/types");
  }

  getAllTransactions(data) {
    return $marketAxios.post("/uc/asset/transaction/all/v2", data);
  }

  getWallet(data) {
    if (data === undefined) {
      return $marketAxios.post("/uc/asset/wallet");
    } else {
      return $marketAxios.post(`/uc/asset/wallet/${data}`);
    }
  }

  // getUserData() {
  //   return $marketAxios.post(`/uc/approve/security/setting`);
  // }

  getWithdrawRecords(data) {
    return $marketAxios.post(`/uc/withdraw/record`, data);
  }

  applyWithdraw(data) {
    return $marketAxios.post(`/uc/withdraw/apply/code/v3`, data);
  }
  getWalletV2() {
    return $marketAxios.post("/uc/asset/wallet/v2");
  }

  checkLogin() {
    return $marketAxios.post("/uc/check/login");
  }

  top5WalletsService() {
    return $marketAxios.get("/uc/asset/top5-wallet-by-usdrate");
  }

  getSmallAssetsList() {
    return $marketAxios.get("/uc/asset/smallAssetsList");
  }
  convertSmallAssets(data) {
    return $marketAxios.post("/uc/asset/convertSmallAssets", data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    });
  }
}

export default new UserCenterService();
